// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1fe1H","modalFooterButton":"ModalNotes_modalFooterButton__1ichZ"};